import { routerPostCall } from '../../axios';

export const uploadFileUrl = '/cms/uploadImage';

const uploadFile = (state, params) => {
  const url = `${uploadFileUrl}?containerName=submit-document&fileName=${params.name}`;
  const data = new FormData();
  data.append('file', params.file);
  return routerPostCall(
    state,
    url,
    data,
    undefined,
    undefined,
    undefined,
    true,
    'multipart/form-data',
  );
};

export default { uploadFile };
